import { useMemo, useState } from "react";
import { CalendarDays } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

const CALENDLY_URL = "https://calendly.com/support-shakatah/30min?primary_color=8552ec";

export function DemoScheduler() {
  const [open, setOpen] = useState(false);

  const calendlyEmbedUrl = useMemo(() => {
    const url = new URL(CALENDLY_URL);
    url.searchParams.set("embed_domain", window.location.hostname);
    url.searchParams.set("embed_type", "Inline");
    url.searchParams.set("hide_event_type_details", "0");
    url.searchParams.set("hide_gdpr_banner", "1");
    return url.toString();
  }, []);

  return (
    <>
      <Button
        type="button"
        onClick={() => setOpen(true)}
        className="fixed bottom-5 right-5 z-40 h-12 rounded-full px-5 text-sm font-semibold shadow-elevated sm:bottom-7 sm:right-7"
      >
        <CalendarDays className="mr-2 h-4 w-4" />
        Schedule a Demo
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[94vh] max-w-4xl overflow-hidden p-0">
          <DialogHeader className="border-b border-border px-6 py-5 pr-12">
            <DialogTitle>Schedule a Splitkart Demo</DialogTitle>
            <DialogDescription>
              Choose a convenient time to speak with our team.
            </DialogDescription>
          </DialogHeader>

          <div className="bg-background p-3 sm:p-4">
            {open ? (
              <iframe
                key="calendly-demo-iframe"
                src={calendlyEmbedUrl}
                title="Schedule a Splitkart demo"
                className="h-[700px] w-full rounded-md border-0"
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
              />
            ) : (
              <div className="h-[700px] w-full animate-pulse rounded-md bg-muted" />
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
